import { z } from 'zod';

import { transformKeysToCamelCase } from 'utils/formatters/transform-snake-to-camel';

export const IsFirstPurchaseSchema = z
  .object({
    data: z.boolean(),
  })
  .transform(transformKeysToCamelCase);

export type TIsFirstPurchaseSchema = z.infer<typeof IsFirstPurchaseSchema>;
export type TFirstPurchaseData = TIsFirstPurchaseSchema['data'];
